import React from 'react';
import { InputLabel, InputLabelProps, withStyles } from '@material-ui/core';
import { BaseTypography } from '../../BaseTypography/BaseTypography';

const StyledLabel = withStyles(() => ({
  formControl: {
    transform: 'none',
    position: 'static',
  },
  root: {
    color: '#1B1A1A',
    transform: 'unset',
    marginBottom: '8px',
  },
}))(InputLabel);

export type BaseInputLabelProps = InputLabelProps;

export const BaseInputLabel: React.FC<BaseInputLabelProps> = (props) => {
  const { children, ...otherProps } = props;
  return (
    <StyledLabel shrink disableAnimation {...otherProps}>
      <BaseTypography variant="caption">{children}</BaseTypography>
    </StyledLabel>
  );
};
